import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { loadSystemLanguage } from '@/lib/settings';

import en from './en.json';
import ru from './ru.json';

const resources = {
  en: { translation: en },
  ru: { translation: ru },
};

// Initialize i18n
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: loadSystemLanguage(), // Load saved language preference
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false,
    },
  });

// Function to change language and save preference
export const changeLanguage = (lang: string) => {
  i18n.changeLanguage(lang);
};

export default i18n;
